/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Grid, SimpleGrid, Input, Button, Modal } from '../../../components/index';
import Masks from '../../../utils/masks';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import MultiplasAtividades from '../templates/MultiplasAtividades';
import { validateObject, trataMensagensErro } from '../../../utils/requests';
import {
  DtpTabGroup,
  DtpTab,
  DtpContentContainer,
} from 'dtp-react-components';
import { DATA_INICIO_MOEDA_REAL } from '../../../utils/ctcHelpers';
import { stringToData } from '../../../utils/helpers';

const pemissoesAcaoPrincipal = ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
const acao = { MARCAR: 'marcar', DESMARCAR: 'desmarcar' };
const checked = (this.state && this.state.ctcAtividade.alunoAprendiz === 1);
const acaoAoClicar = checked ? acao.DESMARCAR : acao.MARCAR;
const VAZIO = '';
// const dataInicioCriacaoRemuneracoes = '01/07/1994';

class ModalAtividade extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    idAtividadeAtual: null,
  });

  formularioProntoParaEnvio = () => {
    const { pertenceSegundaMatricula, dtInicio, dtFim } = { ...this.props.ctcAtividade };
    const { validadeCampos } = { ...this.props.stateAtividade };
    if (pertenceSegundaMatricula === null && validadeCampos.pertenceSegundaMatricula === true && (dtInicio === VAZIO) && (dtFim === VAZIO)) { 
      this.props.limparValidadeCampos(); 
    }
    if (validadeCampos.pertenceSegundaMatricula === false && (dtInicio !== VAZIO) && (dtFim !== VAZIO)) {
      this.props.validarCheckboxSegundaMatricula();
    }
    return validateObject(validadeCampos);
  }

  toggleCheckbox = (acaoToggle, nome) => {
    let changeObj = { isValid: true };
    if (acaoToggle === acao.DESMARCAR) {
      changeObj.value = 0;
    } else {
      changeObj.value = 1;
    }
    this.props.handleChangeCtcAtividade(changeObj, nome);
  };

  montarComplementoTituloModal = () => {
    let temDataInicio = (this.props.stateAtividade.ctcAtividade &&
    this.props.stateAtividade.ctcAtividade.dtInicio !== null && 
    this.props.stateAtividade.ctcAtividade.dtInicio !== '' &&
    this.props.stateAtividade.ctcAtividade.dtInicio.indexOf('_') === -1);

    let temDataFim = (this.props.stateAtividade.ctcAtividade &&
    this.props.stateAtividade.ctcAtividade.dtFim !== null && 
    this.props.stateAtividade.ctcAtividade.dtFim !== '' &&
    this.props.stateAtividade.ctcAtividade.dtFim.indexOf('_') === -1);

    let complemento = '';
    let dtInicio = null;
    let dtFim = null;
    let dataInicioFormat = null;
    let dataFimFormat = null;

    if (temDataInicio && temDataFim) {
      dtInicio = this.props.stateAtividade.ctcAtividade.dtInicio;
      dataInicioFormat = moment(dtInicio, 'DD/MM/YYYY').format('DD/MM/YYYY');
      dtFim = this.props.stateAtividade.ctcAtividade.dtFim;
      dataFimFormat = moment(dtFim, 'DD/MM/YYYY').format('DD/MM/YYYY');
      complemento = `no período de ${dataInicioFormat} a ${dataFimFormat}`;
    }

    return complemento;
  }
  
  validarTotalDiasLiquidoAtividade(tempo, diaQtdLiquido) {
    let retorno = false;
    if(tempo > 0 && tempo >= diaQtdLiquido) {
      retorno = true;   
    } else {
      trataMensagensErro(['Quantidade líquida de dias deve ser maior que zero e menor que diferença da data de início e fim período.']);
    }
    return retorno ;
  }

  verificaSeCampoDesabilitado = (name) => {
    const { acao } = { ...this.props.statePrincipal };
    if (acao === 'detalhar-ctc' || acao === 'detalhar-ctc-invalida') {
      return true;
    }
    return false;
  };

  exibirComboMatriculasCadastradas = () => {
    let { ctc } = { ...this.props.statePrincipal };
    const checkboxMarcado = this.props.statePrincipal.informarSegundaMatricula === 1;
    const temMatricula1 = (ctc.matricula1 !== null && ctc.matricula1 !== VAZIO);
    const temMatricula2 = (ctc.matricula2 !== null && ctc.matricula2 !== VAZIO);
    let retorno = false;

    if (checkboxMarcado && temMatricula1 && temMatricula2) {
      retorno = true;
    }
    return retorno;
  }

  criarTituloPorAtividade = (id, tempoAtividade) => {
    let retorno = VAZIO;
    let tituloOperacao = 'incluir';
    if (tempoAtividade && tempoAtividade.operacao && tempoAtividade.operacao === 2) {
      tituloOperacao = 'alterar';
    }

    switch (id) {
      case 2:
        retorno = `${tituloOperacao} dedução`;
        break;
      case 3:
        retorno = `${tituloOperacao} tempo certificado`;
        break;
      case 4:
        retorno = `${tituloOperacao} tempo especial`;
        break;
      case 5:
        retorno = `${tituloOperacao} remuneração`;
        break;
      default:
        break;
    }
    return retorno;
  }

  determinarNomeListaAtividades = () => {
    const { idAtividadeAtual } = { ...this.state };
    let nomeLista = '';
    switch (idAtividadeAtual) {
      case 1:
        nomeLista = 'atividades';
        break;
      case 2:
        nomeLista = 'afastamentos';
        break;
      case 3:
        nomeLista = 'temposCertificados';
        break;
      case 4:
        nomeLista = 'temposEspeciais';
      break;
      case 5:
        nomeLista = 'remuneracoes';
      break;
      default:
        break;
    }
    return nomeLista;
  }

  criarTituloBotaoPorAtividade = () => {
    const { atividade } = { ...this.props };
    let operacao = 'incluir';
    if (atividade.operacao && atividade.operacao === 2) {
      operacao = 'alterar';
    }
    return operacao;
  }

  exibirDataAdmissao = () => {
    const pertenceMatricula1 = (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula !== null &&
      Number(this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula) === 0);
    const pertenceMatricula2 = (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula !== null &&
      Number(this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula) === 1);

    const temMatricula1 = (this.props.statePrincipal.ctc.matricula1 !== null && this.props.statePrincipal.ctc.matricula1 !== VAZIO);
    const temMatricula2 = (this.props.statePrincipal.ctc.matricula2 !== null && this.props.statePrincipal.ctc.matricula2 !== VAZIO);

    if (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula === '') {
      return '';
    }

    if (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula === null && (temMatricula1 && temMatricula2)) {
      return '';
    } else if (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula === null && (temMatricula1 && !temMatricula2)) {
      return this.props.statePrincipal.ctc.dtAdmissaoMat1;
    }

    if (pertenceMatricula1) {
      return this.props.statePrincipal.ctc.dtAdmissaoMat1;
    }

    if (pertenceMatricula2) {
      return this.props.statePrincipal.ctc.dtAdmissaoMat2;
    }          
  }

  exibirDataDemissao = () => {
    const pertenceMatricula1 = (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula !== null &&
      Number(this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula) === 0);
    const pertenceMatricula2 = (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula !== null &&
      Number(this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula) === 1);

    const temMatricula1 = (this.props.statePrincipal.ctc.matricula1 !== null && this.props.statePrincipal.ctc.matricula1 !== VAZIO);
    const temMatricula2 = (this.props.statePrincipal.ctc.matricula2 !== null && this.props.statePrincipal.ctc.matricula2 !== VAZIO);

    if (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula === '') {
      return '';
    }

    if (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula === null && (temMatricula1 && temMatricula2)) {
      return '';
    } else if (this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula === null && (temMatricula1 && !temMatricula2)) {
      return this.props.statePrincipal.ctc.dtDemissaoMat1;
    }

    if (pertenceMatricula1) {
      return this.props.statePrincipal.ctc.dtDemissaoMat1;
    }

    if (pertenceMatricula2) {
      return this.props.statePrincipal.ctc.dtDemissaoMat2;
    }          
  }

  verificarConcomitancia = (atividades, novaAtividade) => {
    for (let i = 0, tamanhoI = atividades.length; i < tamanhoI; i += 1)  {
      if (novaAtividade.indice != i  ) {
        let atividadeAux = atividades[i];
        if (stringToData(novaAtividade.dtInicio) <= stringToData(atividadeAux.dtFim) && stringToData(atividadeAux.dtInicio) <= stringToData(novaAtividade.dtFim)) {
          return true ;
        }         
      }
    }
    return false;
  }

  tratarConcomitancias = (lista, atividade) => {
    let temConcomitancia = false ;  
    temConcomitancia = this.verificarConcomitancia(lista, atividade);
    return temConcomitancia;
  }


  montaTabs = () => {
    const listaTabs = [];
    listaTabs.push(this.tabAtividade());
    listaTabs.push(this.tabAfastamentos());
    listaTabs.push(this.tabTemposCertificados());
    listaTabs.push(this.tabTemposEspeciais());
    listaTabs.push(this.tabRemuneracoes());
    return listaTabs;
  }

  montaCorpoAtividade = () => {
    const corpoAtividade = (
      <DtpTabGroup className="dtp-default">
        {this.montaTabs()}
      </DtpTabGroup>
    );
    return corpoAtividade;
  }

  formularioAtividade = () => (
    <SimpleGrid>
        <div className="row">
          {(this.exibirComboMatriculasCadastradas()) ?
            <Grid cols="6 6 6 6">
              <Input
                number
                itemList={this.props.statePrincipal.listaMatriculasCadastradas}
                label="Matrícula"
                onChange={e => this.props.handleChangeCtcAtividade(e, 'pertenceSegundaMatricula')}
                placeholder="Selecione a Matrícula"
                touched={this.props.statePrincipal.touched}
                value={this.props.stateAtividade.ctcAtividade.pertenceSegundaMatricula}
                required
                custom
                disabled={this.props.statePrincipal.acao !== 'novo' &&
                  this.props.statePrincipal.acao !== 'editar-rascunho' &&
                  this.props.statePrincipal.acao !== 'revisar-ctc'}
              />
            </Grid>
          :
            <Grid cols="6 6 6 6">
              <Input
                label="Matrícula"
                value={this.props.statePrincipal.ctc.matricula1}
              />
            </Grid>
          }
          <Grid cols="3 3 3 3">
            <Input
              label="Data de admissão"
              mask={Masks.date}
              value={this.exibirDataAdmissao()}
            />
          </Grid>
          <Grid cols="3 3 3 3">
            <Input
              label="Data exoneração / demissão"
              mask={Masks.date}
              value={this.exibirDataDemissao()}
            />
          </Grid>
        </div>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            disabled={this.verificaSeCampoDesabilitado('dtInicio')}
            required
            label="Data início da atividade"
            mask={Masks.date}
            onChange={e => this.props.handleChangeCtcAtividade(e, 'dtInicio')}
            onBlur={e => this.props.validarDatasInicioEFimAtividade()}
            value={this.props.stateAtividade.ctcAtividade.dtInicio}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            disabled={this.verificaSeCampoDesabilitado('dtFim')}
            required
            label="Data fim da atividade"
            mask={Masks.date}
            onChange={e => this.props.handleChangeCtcAtividade(e, 'dtFim')}
            onBlur={e => this.props.validarDatasInicioEFimAtividade()}
            value={this.props.stateAtividade.ctcAtividade.dtFim}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            label="Tempo bruto (dias)"
            readOnly
            value={this.props.stateAtividade.ctcAtividade.diasContribuicaoBruto}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <input
            value={this.props.stateAtividade.alunoAprendiz}
            key="alunoAprendiz"
            label="Aluno Aprendiz"
            type="checkbox"
            checked={checked}
            onClick={() => this.toggleCheckbox(acaoAoClicar, 'alunoAprendiz')}
            style={{ paddingLeft: '5px', position: 'relative', top: '28px' }}
            disabled={['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)}
          />
          <span style={{ paddingLeft: '5px', position: 'relative', top: '25px' }}>aluno aprendiz</span>
        </Grid>
      </div>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            disabled={this.verificaSeCampoDesabilitado('cargo')}
            required
            label="Cargo"
            onChange={e => this.props.handleChangeCtcAtividade(e, 'cargo')}
            value={this.props.stateAtividade.ctcAtividade.cargo}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            disabled={this.verificaSeCampoDesabilitado('cnpj')}
            label="CNPJ"
            mask={Masks.cnpj}
            onChange={e => this.props.handleChangeCtcAtividade(e, 'cnpj')}
            value={this.props.stateAtividade.ctcAtividade.cnpj}
            integer
            exibirBotao={this.props.statePrincipal.acao === 'novo' ||
              this.props.statePrincipal.acao === 'editar-rascunho' ||
              this.props.statePrincipal.acao === 'revisar-ctc'}
            onClickDoBotao={() => this.props.handleSearchCnpjButton('nomeEmpregador', this.props.stateAtividade.ctcAtividade.cnpj)}
            hintDoBotao="Pesquisar cnpj do empregador"
            iconeDoBotao="ico-doc-magnifier"
          />
        </Grid>
        <Grid cols="6 6 6 6">
          <Input
            disabled={this.verificaSeCampoDesabilitado('nomeEmpregador')}
            label="Nome do Empregador"
            maxLength="100"
            onChange={e => this.props.handleChangeCtcAtividade(e, 'nomeEmpregador')}
            value={this.props.stateAtividade.ctcAtividade.nomeEmpregador}
          />
        </Grid>
      </div>
      {/* <div className="row">
        <Grid cols="3 3 3 3" >
          <Input
            disabled={this.verificaSeCampoDesabilitado('ctpsNumero')}
            label="Número CTPS"
            maxLength="11"
            onChange={e => this.props.handleChangeCtcAtividade(e, 'ctpsNumero')}
            value={this.props.stateAtividade.ctcAtividade.ctpsNumero}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            disabled={this.verificaSeCampoDesabilitado('ctpsSerie')}
            label="Série CTPS"
            maxLength="5"
            onChange={e => this.props.handleChangeCtcAtividade(e, 'ctpsSerie')}
            value={this.props.stateAtividade.ctcAtividade.ctpsSerie}
          />
        </Grid>
      </div> */}
    </SimpleGrid>
  );

  verificarDataInicioAtividadeMenorQue1994 = () => {
    let retorno = {};
    let { dtInicio } = {...this.props.stateAtividade.ctcAtividade};
    if(dtInicio !== null) {
      if (moment(dtInicio, 'DD/MM/YYYY').toDate() > moment(DATA_INICIO_MOEDA_REAL, 'DD/MM/YYYY').toDate()) {
        retorno = {value: false};
        this.props.handleChangeCtcAtividade(retorno, 'dataInicioAtividadeMenorQue1994');
      }
    }
  }

  formularioAfastamentos = () => (
    <MultiplasAtividades
      id={2}
      statePrincipal={this.props.statePrincipal}
      stateAtividade={this.props.stateAtividade}
      ctcAtividade={this.props.ctcAtividade}
      tempoAtividade={this.state.ctcAtividadeAfastamento}
      titulo=""
      retirarLinhaSeparadora
      validarDatasInicioEFimAtividade={this.props.validarDatasInicioEFimAtividade}
      ordenarLista={this.props.ordenarLista}
      handleChange={this.props.handleChangeCtcAtividade}
      ordenarAtividadesPorMatriculaEDataInicio={this.props.ordenarAtividadesPorMatriculaEDataInicio}
      calcularTempoAfastamento={this.props.calcularTempoAfastamento}
      tratarConcomitancias={this.tratarConcomitancias}
    />
  )

  formularioTemposCertificados = () => (
    <MultiplasAtividades
      id={3}
      statePrincipal={this.props.statePrincipal}
      stateAtividade={this.props.stateAtividade}
      ctcAtividade={this.props.ctcAtividade}
      tempoAtividade={this.state.ctcAtividadeAfastamento}
      titulo=""
      retirarLinhaSeparadora
      validarDatasInicioEFimAtividade={this.props.validarDatasInicioEFimAtividade}
      ordenarLista={this.props.ordenarLista}
      handleChange={this.props.handleChangeCtcAtividade}
      verificarDestinacaoSelecionadaAtividade={this.props.verificarDestinacaoSelecionadaAtividade}
      desabilitarCheckboxMatriculaEDestinacao={this.props.desabilitarCheckboxMatriculaEDestinacao}
      habilitarCheckboxMatriculaEDestinacao={this.props.habilitarCheckboxMatriculaEDestinacao}
      desabilitarBotaoExcluirLinhaDestinacaoUtilizada={this.props.desabilitarBotaoExcluirLinhaDestinacaoUtilizada}
      habilitarBotaoExcluirLinhaDestinacaoUtilizada={this.props.habilitarBotaoExcluirLinhaDestinacaoUtilizada}
      montarListaDestinacaoTempoCertificado={this.props.montarListaDestinacaoTempoCertificado}
      ordenarAtividadesPorMatriculaEDataInicio={this.props.ordenarAtividadesPorMatriculaEDataInicio}
      calcularTempoLiquidoCertificado={this.props.calcularTempoLiquidoCertificado}
      tratarConcomitancias={this.tratarConcomitancias}
    />
  )

  formularioTemposEspeciais = () => (
    <MultiplasAtividades
      id={4}
      statePrincipal={this.props.statePrincipal}
      stateAtividade={this.props.stateAtividade}
      ctcAtividade={this.props.ctcAtividade}
      tempoAtividade={this.state.ctcAtividadeAfastamento}
      titulo=""
      retirarLinhaSeparadora
      validarDatasInicioEFimAtividade={this.props.validarDatasInicioEFimAtividade}
      ordenarLista={this.props.ordenarLista}
      handleChange={this.props.handleChangeCtcAtividade}
      ordenarAtividadesPorMatriculaEDataInicio={this.props.ordenarAtividadesPorMatriculaEDataInicio}
      calcularTempoEspecial={this.props.calcularTempoEspecial}
      tratarConcomitancias={this.tratarConcomitancias}
    />
  )

  formularioRemuneracoes = () => (
    <MultiplasAtividades
      id={5}
      statePrincipal={this.props.statePrincipal}
      stateAtividade={this.props.stateAtividade}
      ctcAtividade={this.props.ctcAtividade}
      tempoAtividade={this.state.ctcAtividadeAfastamento}
      titulo=""
      retirarLinhaSeparadora
      validarDatasInicioEFimAtividade={this.props.validarDatasInicioEFimAtividade}
      ordenarLista={this.props.ordenarListaRemuneracoes}
      ordenarRemuneracoesPorAno={this.props.ordenarRemuneracoesPorAno}
      ordenarListaRemuneracoes={this.props.ordenarListaRemuneracoes}
      ordenarCompetenciasRemuneracao={this.props.ordenarCompetenciasRemuneracao}
      handleChange={this.props.handleChangeCtcAtividade}
      ordenarAtividadesPorMatriculaEDataInicio={this.props.ordenarAtividadesPorMatriculaEDataInicio}
      tratarConcomitancias={this.tratarConcomitancias}
    />
  )

  tabAtividade = () => (
    <DtpTab
      id="item4"
      className="active"
      title="Período de Contribuição"
    >
      {this.formularioAtividade()}
    </DtpTab>
  );

  tabAfastamentos = () => (
    <DtpTab
      id="item5"
      title="Deduções"
    >
      {this.formularioAfastamentos()}
    </DtpTab>
  );

  tabTemposCertificados = () => (
    <DtpTab
      id="item6"
      title="Tempos Certificados"
      onClick={() => this.props.verificarMudancaTempoLiquidoCertificado()}
    >
      {this.formularioTemposCertificados()}
    </DtpTab>
  );

  tabTemposEspeciais = () => (
    <DtpTab
      id="item7"
      title="Tempos Especiais"
    >
      {this.formularioTemposEspeciais()}
    </DtpTab>
  );

  tabRemuneracoes = () => (
    <DtpTab
      id="item8"
      title="Remunerações"
      onClick={e => this.verificarDataInicioAtividadeMenorQue1994()}
    >
      {this.formularioRemuneracoes()}
    </DtpTab>
  );

  modalContent = () => (
    <React.Fragment>
      <DtpContentContainer>
        {this.montaCorpoAtividade()}
      </DtpContentContainer>
    </React.Fragment>
  )
  
  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        {(!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)) &&
          <ProtectedItem allowedPermissions={pemissoesAcaoPrincipal}>
            <Button
              className="reajustaDireitaBotao"
              disabled={!this.formularioProntoParaEnvio()}
              hint={this.props.stateAtividade.subEstadoFormulario === 'incluir-atividade' ? 'Adicionar atividade' : 'Alterar atividade'}
              onClick={this.props.handleManterAtividade}
              title={this.props.stateAtividade.subEstadoFormulario === 'incluir-atividade' ? 'Adicionar atividade' : 'Alterar atividade'}
            />
          </ProtectedItem>
        }
        {(!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)) &&
          <Button
            className="reajustaDireitaBotao"
            title="cancelar"
            onClick={this.handleClose}
            hint="cancelar"
          />
        }
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.setState(this.props.handleCancelarAcao);
  }

  render() {
    return (
      <Modal
        {...this.props}
        backdrop="static"
        keyboard={false}
        id='modalAtividade'
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="lg"
        showModal={this.props.showModal}
        title={`Atividades ${this.montarComplementoTituloModal()}`}
      />
    );
  }
}

ModalAtividade.propTypes = {
  ctcAtividade: PropTypes.objectOf(PropTypes.object),
  tempoAtividade: PropTypes.objectOf(PropTypes.object),
  showModal: PropTypes.func,
  statePrincipal: PropTypes.objectOf(PropTypes.object),
  stateAtividade: PropTypes.objectOf(PropTypes.object),
  ordenarLista: PropTypes.func,
  ordenarListaRemuneracoes: PropTypes.func,
  ordenarRemuneracoesPorAno: PropTypes.func,
  ordenarCompetenciasRemuneracao: PropTypes.func,
  ordenarAtividadesPorMatriculaEDataInicio: PropTypes.func,
  determinarNomeListaAtividades: PropTypes.func,
  verificarListaInclusao: PropTypes.func,
  verificarDestinacaoSelecionadaAtividade: PropTypes.func,
  validarDiasContribuicaoBruto: PropTypes.func,
  validarDatasInicioEFimAtividade: PropTypes.func,
  handleCancelarAcao: PropTypes.func,
  handleChangeCtcAtividade: PropTypes.func,
  handleManterAtividade: PropTypes.func,
  desabilitarBotaoExcluirLinhaDestinacaoUtilizada: PropTypes.func,
  habilitarBotaoExcluirLinhaDestinacaoUtilizada: PropTypes.func,
  desabilitarCheckboxMatriculaEDestinacao: PropTypes.func,
  habilitarCheckboxMatriculaEDestinacao: PropTypes.func,
  handleExcluirAtividade: PropTypes.func,
  montarListaDestinacaoTempoCertificado: PropTypes.func,
  handleSearchCnpjButton: PropTypes.func,
  calcularTempoLiquidoCertificado: PropTypes.func,
  calcularTempoAfastamento: PropTypes.func,
  calcularTempoEspecial: PropTypes.func,
  verificarMudancaTempoLiquidoCertificado: PropTypes.func,
  validarCheckboxSegundaMatricula: PropTypes.func,
  limparValidadeCampos: PropTypes.func,
}.isRequired;

export default ModalAtividade;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/ModalAtividade.jsx